// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Shadow UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* ezClockerStone Shadows: --ezBorderStone: #666565; */
  --ezStoneShadowColor: var(--ezStoneBorder);
  --ezStoneInsetBoxShadow: inset 0 0 4px 2px rgb(102 101 101 / 50%);
  --ezStoneBoxShadow: 0 0 1px 1px rgb(102 101 101 / 50%);
  --ezStoneInsetBottomShadow: inset 0 -2px 4px -2px rgb(102 101 101 / 50%);
  --ezStoneBottomShadow: 0 2px 2px -2px rgb(102 101 101 / 50%);
  --ezStoneTopShadow: 0 -2px 2px 0 rgb(102 101 101 / 50%);
  --ezStoneLeftShadow: -2px 0 2px 0 rgb(102 101 101 / 50%);
  --ezStoneRightShadow: 2px 0 2px 0 rgb(102 101 101 / 50%);
  --ezStoneTopRightShadow: 4px -4px 4px 0 rgb(102 101 101 / 50%);
  --ezStopTopLeftShadow: -4px -4px 4px 0 rgb(102 101 101 / 50%);
  --ezStoneBottomLeftShadow: -4px 4px 4px 0 rgb(102 101 101 / 50%);
  --ezStoneInsetTopLeft: inset 2px 2px 2px 0 rgb(102 101 101 / 50%);
  --ezStoneInsetTopRight: inset -2px 2px 2px 0 rgb(102 101 101 / 50%);
  /* ezClockerTeal Shadows: --ezTealBorder #007c82 */
  --ezTealShadowColor: var(--ezTealBorder);
  --ezTealInsetBoxShadow: inset 0 0 4px 2px rgb(0 124 130 / 100%);
  --ezTealBoxShadow: 0 0 1px 1px rgb(0 124 130 / 100%);
  --ezTealInsetBottomShadow: inset 0 -2px 4px -2px rgb(0 124 130 / 100%);
  --ezTealBottomShadow: 0 4px 4px -2px rgb(0 124 130 / 100%);
  --ezTealTopShadow: 0 -4px 4px 0 rgb(0 124 130 / 100%);
  --ezTealLeftShadow: -4px 0 4px 0 rgb(0 124 130 / 100%);
  --ezTealRightShadow: 4px 0 4px 0 rgb(0 124 130 / 100%);
  /* ezClockerNavy Shadows: --ezBorderNavy: #032746; */
  --ezNavyShadowColor: var(--ezBorderNavy);
  --ezNavyInsetShadow: inset 0 0 4px 2px rgb(3 39 70 / 100%);
  --ezNavyBoxShadow: 0 0 1px 1px rgb(3 39 70 / 100%);
  --ezNavyInsetBottomShadow: inset 0 -4px 4px 0 rgb(3 39 70 / 50%);
  --ezNavyBottomShadow: 0 2px 4px 0 rgb(3 39 70 / 100%);
  --ezNavyTopShadow: 0 -2px 2px 0 rgb(3 39 70 / 100%);
  --ezNavyLeftShadow: -2px 0 2px 0 rgb(3 39 70 / 100%);
  --ezNavyRightShadow: 2px 0 2px 0 rgb(3 39 70 / 100%);
  /* ezClockerBlack Shadows: --ezBorderBlack: #030101 */
  --ezBlackShadowColor: var(--ezBorderBlack);
  --ezBlackInsetBottomShadow: inset 0 -2px 4px -2px rgb(3 1 1 / 100%);
  --ezBlackBottomShadow: 0 2px 2px -2px rgb(3 1 1 / 100%);
  --ezBlackTopShadow: 0 -2px 2px 0 rgb(3 1 1 / 100%);
  --ezBlackLeftShadow: -2px 0 2px 0 rgb(3 1 1 / 100%);
  --ezBlackRightShadow: 2px 0 2px 0 rgb(3 1 1 / 100%);
  --ezBlackThickBottomShadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8);
}

/* Shadows */
.ezShadows-0-0-10px-0-ezClockerBlack {
  box-shadow: 0 0 10px 0 var(--ezClockerBlack);
}

.ezShadows-inset-shadow {
  box-shadow: rgb(0, 0, 0) 3px 3px 6px 0 inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
}

.ez-bottom-shadow {
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

.ezShadows-wide-bottom-shadow {
  box-shadow: 0 4px 4px 0 rgb(109 110 112/50%);
}

.ez-inset-bottom-shadow {
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadow-overlay-inset-bottom {
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadow-overlay-inset-bottom:before {
  content: "";
  position: absolute;
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ez-right-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-inset-right-shadow {
  box-shadow: inset -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezShadows-inset-right-left-bottom-shadow {
  box-shadow: inset -2px 0 2px 0 rgb(109 110 112/50%), inset 2px 0 2px 0 rgb(109 110 112/50%), inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadows-inset-box-2px {
  box-shadow: inset 2px 0 2px 0 rgb(109 110 112/50%), inset -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezShadows-inset-box-2px:after {
  box-shadow: inset 0 2px 2px 0 rgb(109 110 112/50%), inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ez-left-shadow {
  box-shadow: -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-inset-left-shadow {
  box-shadow: inset 2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-top-shadow {
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%);
}

.ez-inset-top-shadow {
  box-shadow: inset 0 2px 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-top-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%), inset 0 2px 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-bottom-shadow {
  box-shadow: 0 2px 4px 1px rgb(109 110 112/50%);
}

.ez-shadow {
  box-shadow: 0 0 4px 2px rgb(109 110 112/50%);
}

.ez-shadow-small {
  box-shadow: 0 0 2px 2px var(--ezClockerGray);
}

.ez-shadow-dark {
  box-shadow: 0 2px 8px 4px rgb(0 0 0/50%);
}

.ez-inset-shadow {
  box-shadow: inset 0 0 8px 4px rgb(109 110 112/50%);
}

.ez-small-inset-shadow {
  box-shadow: inset 0 0 4px 2px rgb(109 110 112/50%);
}

.ez-left-top-inset-shadow {
  box-shadow: inset 2px 2px 4px 2px rgb(109 110 112/50%);
}

/* DEPRECATED */
.leftRightBottomShadow {
  box-shadow: 0 2px 4px 1px rgb(109 110 112/50%);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-shadows.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,sDAAA;EACA,0CAAA;EACA,iEAAA;EACA,sDAAA;EACA,wEAAA;EACA,4DAAA;EACA,uDAAA;EACA,wDAAA;EACA,wDAAA;EACA,8DAAA;EACA,6DAAA;EACA,gEAAA;EACA,iEAAA;EACA,mEAAA;EAEA,kDAAA;EACA,wCAAA;EACA,+DAAA;EACA,oDAAA;EACA,sEAAA;EACA,0DAAA;EACA,qDAAA;EACA,sDAAA;EACA,sDAAA;EAEA,oDAAA;EACA,wCAAA;EACA,0DAAA;EACA,kDAAA;EACA,gEAAA;EACA,qDAAA;EACA,mDAAA;EACA,oDAAA;EACA,oDAAA;EAEA,qDAAA;EACA,0CAAA;EACA,mEAAA;EACA,uDAAA;EACA,kDAAA;EACA,mDAAA;EACA,mDAAA;EACA,+DAAA;AAHJ;;AAMA,YAAA;AACA;EACI,4CAAA;AAHJ;;AAMA;EACI,8FACI;AAJR;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,sDAAA;AALJ;;AAQA;EACI,sDAAA;AALJ;;AAQA;EACI,WAAA;EACA,kBAAA;EACA,sDAAA;AALJ;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,mDAAA;AALJ;;AAQA;EACI,uIAEI;AAPR;;AAcA;EACI,2FAEI;AAbR;;AAkBA;EACI,8FAEI;AAjBR;;AAsBA;EACI,6CAAA;AAnBJ;;AAsBA;EACI,+EAEI;AArBR;;AA0BA;EACI,kDAAA;AAvBJ;;AA0BA;EACI,6CAAA;AAvBJ;;AA0BA;EACI,kDAAA;AAvBJ;;AA0BA;EACI,uHAEI;AAzBR;;AAgCA;EACI,8CAAA;AA7BJ;;AAgCA;EACI,4CAAA;AA7BJ;;AAgCA;EACI,4CAAA;AA7BJ;;AAgCA;EACI,wCAAA;AA7BJ;;AAgCA;EACI,kDAAA;AA7BJ;;AAgCA;EACI,kDAAA;AA7BJ;;AAgCA;EACI,sDAAA;AA7BJ;;AAgCA,eAAA;AACA;EACI,8CAAA;AA7BJ;;AAgCA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Shadow UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n:root {\r\n    /* ezClockerStone Shadows: --ezBorderStone: #666565; */\r\n    --ezStoneShadowColor: var(--ezStoneBorder);\r\n    --ezStoneInsetBoxShadow: inset 0 0 4px 2px rgb(102 101 101 / 50%);\r\n    --ezStoneBoxShadow: 0 0 1px 1px rgb(102 101 101 / 50%);\r\n    --ezStoneInsetBottomShadow: inset 0 -2px 4px -2px rgb(102 101 101 / 50%);\r\n    --ezStoneBottomShadow: 0 2px 2px -2px rgb(102 101 101 / 50%);\r\n    --ezStoneTopShadow: 0 -2px 2px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneLeftShadow: -2px 0 2px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneRightShadow: 2px 0 2px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneTopRightShadow: 4px -4px 4px 0 rgb(102 101 101 / 50%);\r\n    --ezStopTopLeftShadow: -4px -4px 4px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneBottomLeftShadow: -4px 4px 4px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneInsetTopLeft: inset 2px 2px 2px 0 rgb(102 101 101 / 50%);\r\n    --ezStoneInsetTopRight: inset -2px 2px 2px 0 rgb(102 101 101 / 50%);\r\n\r\n    /* ezClockerTeal Shadows: --ezTealBorder #007c82 */\r\n    --ezTealShadowColor: var(--ezTealBorder);\r\n    --ezTealInsetBoxShadow: inset 0 0 4px 2px rgb(0 124 130 / 100%);\r\n    --ezTealBoxShadow: 0 0 1px 1px rgb(0 124 130 / 100%);\r\n    --ezTealInsetBottomShadow: inset 0 -2px 4px -2px rgb(0 124 130 / 100%);\r\n    --ezTealBottomShadow: 0 4px 4px -2px rgb(0 124 130 / 100%);\r\n    --ezTealTopShadow: 0 -4px 4px 0 rgb(0 124 130 / 100%);\r\n    --ezTealLeftShadow: -4px 0 4px 0 rgb(0 124 130 / 100%);\r\n    --ezTealRightShadow: 4px 0 4px 0 rgb(0 124 130 / 100%);\r\n\r\n    /* ezClockerNavy Shadows: --ezBorderNavy: #032746; */\r\n    --ezNavyShadowColor: var(--ezBorderNavy);\r\n    --ezNavyInsetShadow: inset 0 0 4px 2px rgb(3 39 70 / 100%);\r\n    --ezNavyBoxShadow: 0 0 1px 1px rgb(3 39 70 / 100%);\r\n    --ezNavyInsetBottomShadow: inset 0 -4px 4px 0 rgb(3 39 70 / 50%);\r\n    --ezNavyBottomShadow: 0 2px 4px 0 rgb(3 39 70 / 100%);\r\n    --ezNavyTopShadow: 0 -2px 2px 0 rgb(3 39 70 / 100%);\r\n    --ezNavyLeftShadow: -2px 0 2px 0 rgb(3 39 70 / 100%);\r\n    --ezNavyRightShadow: 2px 0 2px 0 rgb(3 39 70 / 100%);\r\n\r\n    /* ezClockerBlack Shadows: --ezBorderBlack: #030101 */\r\n    --ezBlackShadowColor: var(--ezBorderBlack);\r\n    --ezBlackInsetBottomShadow: inset 0 -2px 4px -2px rgb(3 1 1 / 100%);\r\n    --ezBlackBottomShadow: 0 2px 2px -2px rgb(3 1 1 / 100%);\r\n    --ezBlackTopShadow: 0 -2px 2px 0 rgb(3 1 1 / 100%);\r\n    --ezBlackLeftShadow: -2px 0 2px 0 rgb(3 1 1 / 100%);\r\n    --ezBlackRightShadow: 2px 0 2px 0 rgb(3 1 1 / 100%);\r\n    --ezBlackThickBottomShadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n/* Shadows */\r\n.ezShadows-0-0-10px-0-ezClockerBlack {\r\n    box-shadow: 0 0 10px 0 var(--ezClockerBlack);\r\n}\r\n\r\n.ezShadows-inset-shadow {\r\n    box-shadow:\r\n        rgb(0,0,0) 3px 3px 6px 0 inset,\r\n        rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;\r\n}\r\n\r\n.ez-bottom-shadow {\r\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadows-wide-bottom-shadow {\r\n    box-shadow: 0 4px 4px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-inset-bottom-shadow {\r\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadow-overlay-inset-bottom {\r\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadow-overlay-inset-bottom:before {\r\n    content: '';\r\n    position: absolute;\r\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-right-shadow {\r\n    box-shadow: 2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-inset-right-shadow {\r\n    box-shadow: inset -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadows-inset-right-left-bottom-shadow {\r\n    box-shadow:\r\n        /* right */\r\n        inset -2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        /* left */\r\n        inset 2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        /* bottom */\r\n        inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadows-inset-box-2px {\r\n    box-shadow:\r\n        /* left */\r\n        inset 2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        /* right */\r\n        inset -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezShadows-inset-box-2px:after {\r\n    box-shadow:\r\n        /* top */\r\n        inset 0 2px 2px 0 rgb(109 110 112 / 50%),\r\n        /* bottom */\r\n        inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-left-shadow {\r\n    box-shadow: -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-left-right-shadow {\r\n    box-shadow:\r\n        /* left */\r\n        2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        /* right */\r\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-inset-left-shadow {\r\n    box-shadow: inset 2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-top-shadow {\r\n    box-shadow: 0 -2px 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-inset-top-shadow {\r\n    box-shadow: inset 0 2px 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-left-right-top-shadow {\r\n    box-shadow:\r\n        /* left */\r\n        2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        /* top */\r\n        inset 0 2px 2px 0 rgb(109 110 112 / 50%),\r\n        /* right */\r\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-left-right-bottom-shadow {\r\n    box-shadow: 0 2px 4px 1px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-shadow {\r\n    box-shadow: 0 0 4px 2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-shadow-small {\r\n    box-shadow: 0 0 2px 2px var(--ezClockerGray);\r\n}\r\n\r\n.ez-shadow-dark {\r\n    box-shadow: 0 2px 8px 4px rgb(0 0 0 / 50%);\r\n}\r\n\r\n.ez-inset-shadow {\r\n    box-shadow: inset 0 0 8px 4px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-small-inset-shadow {\r\n    box-shadow: inset 0 0 4px 2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ez-left-top-inset-shadow {\r\n    box-shadow: inset 2px 2px 4px 2px rgb(109 110 112 / 50%);\r\n}\r\n\r\n/* DEPRECATED */\r\n.leftRightBottomShadow {\r\n    box-shadow: 0 2px 4px 1px rgb(109 110 112 / 50%);\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n}\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
